import React from "react";
import ContactArea from "../ContactArea/ContactArea";
import "./Help.css";

function Help() {
  return (
    <div>
      <ContactArea />
    </div>
  );
}

export default Help;
